import { Component, Input, OnInit } from "@angular/core";
import { ElementComponent } from "./element.component";

@Component({
  selector: "n-text",
  template: ` <div class="n-text">{{ text }}</div> `,
})
export class TextComponent extends ElementComponent implements OnInit {
  @Input("text")
  text: string = "";

  ngOnInit() {
    super.ngOnInit();
  }
}
